import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ChevronRight, Home } from 'lucide-react';

const ORIGIN = 'https://freeserpchecker.org';

const Breadcrumb = ({ items = [] }) => {
  // Legal pages pass a leading { label: 'Home', href: '/' }; content pages don't.
  // Drop any leading Home item so we never render a double "Home" (the Home link
  // below is always rendered as the first crumb).
  const crumbs = items.filter((it) => it.href !== '/' && it.label !== 'Home');

  if (crumbs.length === 0 && items.length === 0) return null;

  // BreadcrumbList schema (B9): Home + the cleaned crumbs, in order.
  const itemListElement = [
    { '@type': 'ListItem', position: 1, name: 'Home', item: `${ORIGIN}/` },
    ...crumbs.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 2,
      name: it.label,
      item: it.href.startsWith('http') ? it.href : `${ORIGIN}${it.href}`,
    })),
  ];

  return (
    <nav className="bg-gray-50 border-b border-gray-200" aria-label="Breadcrumb">
      <Helmet defer={false}>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement,
          })}
        </script>
      </Helmet>
      <div className="container-max">
        <div className="flex items-center space-x-2 py-3 text-sm">
          <a href="/" className="flex items-center space-x-1 text-gray-600 hover:text-blue-600 transition-colors">
            <Home className="w-4 h-4" />
            <span>Home</span>
          </a>
          {crumbs.map((item, index) => (
            <React.Fragment key={index}>
              <ChevronRight className="w-4 h-4 text-gray-400" />
              {index === crumbs.length - 1 ? (
                <span className="text-gray-900 font-medium">{item.label}</span>
              ) : (
                <a href={item.href} className="text-gray-600 hover:text-blue-600 transition-colors">
                  {item.label}
                </a>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Breadcrumb;
